<template>
  <div class="logoTitle">
    <router-link :to="{name:'dashboard'}">
      <!--<img alt="logo" :src="$_c + 'img/logo_gdemc.png'" />-->
      <div>
        <h1 v-if="showTitle">专家管理系统</h1>
        <!--<h1 v-if="showTitle">广州市应急管理局</h1>-->
        <!--<p style="color: white">{{ title }}</p>-->
      </div>

    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    LogoSvg
  },
  props: {
    title: {
      type: String,
      default: '专家管理系统',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>

<style lang="less">
  .sider .logo img {
    width: 64px !important;
    height: 64px !important;
    padding: 0 !important;
  }
  .ant-layout-sider-collapsed{
    .logoTitle{
      a{
        display: block;
        margin: auto;
        div{
          display: none;
        }
        img{
          margin: auto;
          display: block;
        }
      }
    }
  }
  .ant-layout-sider-collapsed.sider .logo img {
    width: 32px !important;
    height: 32px !important;
  }
  .logoTitle {
    position: absolute;
    top: 0;
    left: 0;
    /*width: 100%;*/
    height: 64px;
    //line-height: 64px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background: #002140;
    overflow: hidden;
    z-index: 9;
    a{
      display: flex;
      align-items: center;
    }

    img,
    svg,
    h1 {
      display: inline-block;
      vertical-align: middle;
    }

    img,
    svg {
      height: 32px;
      width: 32px;
      margin-right: 8px;
    }

    h1 {
      color: #fff;
      font-size: 17px;
      margin: 0;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      font-weight: 600;
      vertical-align: middle;
    }
    p{
      margin: 0;
    }

  }
</style>
